module.exports = __webpack_public_path__ + "img/group-img.3d473201.svg";